import { IHelpdeskCreateRequest } from '@/redux/modules/Helpdesk';
import { server } from '../core/server/axios';
import { BACKEND_URL } from '@/core/config';

export class HelpdeskController {

    async getHelpdeskDictionary(): Promise<any> {
        return await server.get('/Generic/Helpdesk', {
            baseURL: BACKEND_URL
        });
    }

    async compressImage(imageData: File): Promise<any> {
        const formData = new FormData();
        formData.append("file", imageData);

        return await server.post(
            '/Helpdesk/compress-file',
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                baseURL: BACKEND_URL,
            },

        );
    }

    async createTicket(ticket: IHelpdeskCreateRequest): Promise<any> {
        return await server.post('/Helpdesk/create-ticket', ticket, {
            baseURL: BACKEND_URL
        });
    }

    async getTicketsByRole(role: string[], page: number, size: number): Promise<IHelpdeskCreateRequest[]> {
        return await server.post(`/Helpdesk/open-tickets-by-role?page=${page}&size=${size}`, role, {
            baseURL: BACKEND_URL
        });
    }
    async getTicketsByLogin(login: string, page: number, size: number): Promise<IHelpdeskCreateRequest[]> {
        return await server.get(`/Helpdesk/assignee/${login}/${page}/${size}`, {
            baseURL: BACKEND_URL
        });
    }

    async getCloseTickets(login: string, page: number, size: number): Promise<IHelpdeskCreateRequest[]> {
        return await server.get(`/Helpdesk/closed-tickets/${login}/${page}/${size}`, {
            baseURL: BACKEND_URL
        });
    }

    async getTicketByIdAsync(id: number): Promise<any> {
        return await server.get(`/Helpdesk/${id}`, {
            baseURL: BACKEND_URL
        })
    }
    async getTicketMain(id: Number[]): Promise<IHelpdeskCreateRequest[]> {
        return await server.post(`/Helpdesk/main-info`, id, {
            baseURL: BACKEND_URL
        })
    }
    async getUserTickets(login: string, page: number, size: number): Promise<IHelpdeskCreateRequest[]> {
        return await server.get(`/Helpdesk/user/${login}/${page}/${size}`, {
            baseURL: BACKEND_URL
        })
    }
    async getUserTicketSize(login: string): Promise<Number> {
        return await server.get(`/Helpdesk/user/size/${login}`, {
            baseURL: BACKEND_URL
        })
    }
    async getDocById(id: number): Promise<string> {
        return await server.get(`/Helpdesk/get-image/${id}`, {
            baseURL: BACKEND_URL
        })
    }

    async updateTicket(id: number, status: string, assignee: string): Promise<any> {
        return await server.put(`/Helpdesk/update-ticket`, { id: id, status: status, assignee: assignee }, {
            baseURL: BACKEND_URL
        })
    }

    async addStep(ticket: any): Promise<any> {
        return await server.post(`/Helpdesk/add-step/${ticket.id}`, ticket, {
            baseURL: BACKEND_URL
        })
    }
}

